
<div *ngIf="errorMessages.length > 0" class="acknowledgementSliderErrorMessagePlaceHolder">
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="p-message-wrapper">
        <div>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">{{errorMessageHeaderText}}</span>        
      </div>
      <div>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </div>
    </div>
    </ng-template>
  </p-messages>
</div>

<form [formGroup]="acknowledgementForm">
  <div class="general-tab">
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Assigned Internal User"
          [options]="userList ?? []"
          [editable]="false"
          id="assignedInternalUser"
          placeholder="Select User"
          formControlName="assignedInternalUser"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['assignedUser'] }"
        >
        </bpt-dropdown>
      </div>
      </div>
      <div class="fields-row">
      <div class="field field-required"  *ngIf="isDueDateActive">
        <bpt-datetime
          id="acknowledgementDueDate"
          [minDate]="minDueDateValue.toString()"
          placeholder="Enter or select a due date"
          label={{dueDateLabel}}
          formControlName="dueDate"
          [ngClass]="{ 'error-highlight': mandatoryFields['dueDate'] }"
        ></bpt-datetime>
      </div>      
    </div>
  </div>
  <div class="buttons">
    <p-button
    appPreventDoubleClick
      label="Save"
      type="submit"
      id="acknowledhementDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="saveHardcopyAcknowledgement()"
    >
    </p-button>  
  </div>
</form>